import { Instagram, Linkedin, Music2, Twitter, Youtube } from "lucide-react";
import SEO from "../components/SEO";
import { BRAND_LABEL, LEGAL_NAME, SOCIAL_PROFILES } from "../config/branding";

const icons = {
  TikTok: Music2,
  Instagram,
  YouTube: Youtube,
  X: Twitter,
  LinkedIn: Linkedin,
};

export default function Socials() {
  return (
    <>
      <SEO
        title={`Official ${BRAND_LABEL} Social Media | TikTok, Instagram, YouTube, X & LinkedIn`}
        description={`Find and follow the official ${BRAND_LABEL} accounts on TikTok, Instagram, YouTube, X, and LinkedIn. These profiles belong to ${LEGAL_NAME}.`}
        url="https://www.jisedai.africa/socials"
      />

      <main className="min-h-screen bg-[#eeeee8] px-5 pb-24 pt-32 text-[#111712] sm:px-8 md:px-12">
        <section className="mx-auto max-w-5xl">
          <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#45695a]">
            Official accounts
          </p>
          <h1 className="mt-5 max-w-3xl font-serif text-5xl leading-[0.94] tracking-[-0.055em] md:text-7xl">
            Follow {BRAND_LABEL} on social media
          </h1>
          <p className="mt-6 max-w-3xl text-lg leading-8 text-[#4d5951]">
            Connect with {LEGAL_NAME} for AI insights, product updates, events,
            learning opportunities, and stories from Africa&apos;s technology
            ecosystem.
          </p>

          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {SOCIAL_PROFILES.map((profile) => {
              const Icon = icons[profile.name];

              return (
                <a
                  key={profile.name}
                  href={profile.url}
                  target="_blank"
                  rel="me noopener noreferrer"
                  aria-label={`Follow ${BRAND_LABEL} on ${profile.name} at ${profile.handle}`}
                  className="group rounded-2xl border border-[#111712]/15 bg-[#f7f7f2] p-6 transition hover:-translate-y-1 hover:border-[#45695a]/40 hover:shadow-xl hover:shadow-[#45695a]/10"
                >
                  <Icon className="h-7 w-7 text-[#45695a]" aria-hidden="true" />
                  <h2 className="mt-5 font-serif text-2xl tracking-[-0.03em]">
                    {BRAND_LABEL} on {profile.name}
                  </h2>
                  <p className="mt-2 text-[#4d5951]">{profile.handle}</p>
                  <span className="mt-5 inline-block text-sm font-bold text-[#45695a] group-hover:text-[#111712]">
                    Visit official {profile.name} profile →
                  </span>
                </a>
              );
            })}
          </div>
        </section>
      </main>
    </>
  );
}
